import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import './GrillasStyles.css';
import authContext from "../../context/authentication/authContex";
import informesContext from "../../context/informesContext/informesContext";
import usuariosContext from "../../context/usuarios/usuariosContext";
import normalizeText from "../../utils/normalizeText";
import { getJugadoresObservados } from "../../api/reservas";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";

import SearchInput from "../searchInput/SearchInput";
import SelectColumns from "./SelectColumns";
import Table from "./Table";

const GrillaJugadoresObservados = ({setGridToShow}) => {

    const aContext = useContext(authContext);
    const { usuario } = aContext;

    const uContext = useContext(usuariosContext);
    const { saveColumnsPreferences } = uContext;

    const iContext = useContext(informesContext);
    const { generarInformeExcel } = iContext;

    let columnsPreferences = useMemo(()=> usuario?.columnsPreferences?.columnasJugadoresObservados ?? [], [usuario]);

    const dataOriginal = useRef(undefined);
    const [data, setData] = useState(undefined);
    const [filter, setFilter] = useState('');
    const [showSelectColumns, setShowSelectColumns] = useState(false);
    const [loading, setLoading] = useState(true);

    const firstLoadRef = useRef(true);

    const [columns, setColumns] = useState([
        { width: 400, property: 'nombreCompleto', title: 'Nombre Completo', visible: true },
        { width: 250, property: 'userName', title: 'Username', visible: true },
        { width: 200, property: 'nroSocio', title: 'NroSocio', visible: true },
        { width: 200, property: 'cantidadObservaciones', title: 'Cantidad Observaciones', visible: true },
    ]);

    const handleBuscar = async () => {
        setLoading(true);
        setFilter('');
        try {
            const resp = await getJugadoresObservados();
            const rows = resp?.data?.data ?? [];
            dataOriginal.current = rows;
            setData(rows);
        } catch (error) {
            console.log("error en GrillaJugadoresObservados handleBuscar");
            console.log(error);
            dataOriginal.current = [];
            setData([]);
        }
        setLoading(false);
    }

    // Carga inicial
    useEffect(()=>{
        if(firstLoadRef.current){
            firstLoadRef.current = false;
            handleBuscar();
        }
    },[]);

    const handleChangeColumnsVisible = (e, c, i) => {
        setColumns(prev => prev.map((col, idx) => idx == i ? {...col, visible: e.target.checked} : col));
    }

    const handleGenerarInforme = async() => {
        let dataToExcel = [];
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title);
        dataToExcel.push(columnsTitle);

        for(const row of data){
            let rowModelado = [];
            for(const col of columns){
                if(!col.visible) continue;
                rowModelado.push(row[col.property]);
            }
            if(rowModelado.length > 0) dataToExcel.push(rowModelado);
        }
        await generarInformeExcel(dataToExcel, `JugadoresObservados`);
    }

    // Filtro por texto sobre data original
    useEffect(()=>{
        if(dataOriginal.current == undefined) return;
        if(filter != ''){
            const nFilter = normalizeText(filter);
            setData(dataOriginal.current.filter(r =>
                normalizeText(r.nombreCompleto ?? '').includes(nFilter) ||
                normalizeText(r.userName ?? '').includes(nFilter) ||
                normalizeText(String(r.nroSocio ?? '')).includes(nFilter)
            ));
        }else{
            setData(dataOriginal.current);
        }
    },[filter]);

    useEffect(()=>{
        if(columnsPreferences && columnsPreferences.length > 0){
            setColumns(prev => prev.map(c => ({...c, visible: columnsPreferences.includes(c.property)})));
        }
    },[columnsPreferences]);

    return <div className="grillaInformeDiv jugadoresObservados">
        <div className="utilitiesDiv">
            <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
            <SearchInput filter={filter} buscar={setFilter}/>
            <button className="selectColumnsBtn" onClick={()=>setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells}/></button>
            <button disabled={loading || data == undefined || data.length == 0} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload}/></button>
        </div>
        {
            loading ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3>
            : data == undefined ? <h3 className="warningStatusMsg">Sin datos</h3>
            : data.length == 0 ? <h3 className="warningStatusMsg">No hay jugadores en reservas observadas</h3>
            : <Table array={data} columns={columns} setColumns={setColumns}/>
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"JugadoresObservados"}/>
        }
    </div>
}

export default GrillaJugadoresObservados;
